module.exports = __webpack_public_path__ + "static/media/higuchi-building-2.b88dbc6a.jpg";